var map = {
	"./Bejing2022.vue": [
		876,
		64
	],
	"./CoronaVaccinations.vue": [
		859,
		12,
		65
	],
	"./Coronavirus.vue": [
		858,
		12,
		77,
		66
	],
	"./CoronavirusAPA.vue": [
		872,
		67
	],
	"./Eliteliga.vue": [
		641,
		2,
		3
	],
	"./EliteligaTopWidget.vue": [
		627,
		2,
		68
	],
	"./GrundUndBoden.vue": [
		873,
		69
	],
	"./RegionalQuestionaire.vue": [
		869,
		4,
		9
	],
	"./RegionalQuestionaireQuestion.vue": [
		684,
		70
	],
	"./RessortTitle.vue": [
		601,
		71
	],
	"./SoccerLeagueButtons.vue": [
		617,
		72
	],
	"./VorteilsclubHeader.vue": [
		874,
		73
	],
	"./Webinar.vue": [
		875,
		74
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 694;
module.exports = webpackAsyncContext;